import { createBlockErrorReporter } from "@zillow/cms-utils/block-error-reporting";
import { setBlockErrorSink } from "@zillow/cms-utils/block-error-reporting";
import { frontierModules } from "./frontier-modules.esm.js";
const {
  enrichRumEvent,
  makeRemoteErrorHandler,
  reportBlockError,
  resolveBlockAttribution
} = createBlockErrorReporter(frontierModules);
export {
  enrichRumEvent,
  makeRemoteErrorHandler,
  reportBlockError,
  resolveBlockAttribution,
  setBlockErrorSink
};
